export default {
  title: 'Contact Support',
  form: {
    firstName: 'First Name',
    lastName: 'Last Name',
    nickname: 'Nickname',
    phoneNumber: 'Phone Number',
    email: 'Email',
    emailVerification: 'Email Verification',
    subject: {
      label: 'Issue Type',
      options: ['Bug', 'Billing', 'Connectivity', 'Feedback', 'Improvement'],
    },
    message: 'Message',
    button: 'Send',
  },
  errors: {
    requiredField: 'This filed is required.',
    sendFailed: 'Something went wrong',
  },
  success: {
    title: 'Got it!',
    message: 'One of our support agents will get back to you as soon as possible.',
  },
};
